import { PureComponent, ReactNode } from 'react'
import { createScriptLoader } from '@bigcommerce/script-loader'

interface Props {
  children: ReactNode
}

export default class LiveChat extends PureComponent<Props> {
  static loaded = false

  initialize () {
    if (LiveChat.loaded) return
    const loader = createScriptLoader()
    const tidioScriptId = process.env.REACT_APP_TIDIO_SCRIPT_ID
    const src = `https://code.tidio.co/${tidioScriptId}.js`
    loader.loadScript(src, { async: true, attributes: {} })
      .then(() => {
        LiveChat.loaded = true
      })
  }

  componentDidMount () {
    this.initialize()
  }

  render () {
    return this.props.children
  }
}
